<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
		<v-tabs
			show-arrows
			:height="32"
			class="tabs-route"
			background-color="transparent"
			slider-color="primary">
			<v-tab>
				Evasione Ordine in DDT
			</v-tab>
		</v-tabs>
		<v-col class="pa-0">
			<show
				:id="id"
				:models="models"
				:infos="infos"
				topClass=""
			></show>

			<v-col class="pa-0 pb-4" v-if="relations.products">
				<v-card class="flex pa-0 background-2 round-card">
					<v-card-title class="pa-3">
						<p class="pl-2 pl-xl-3">Evasione Ordine in DDT</p>
						<v-spacer></v-spacer>
						<v-text-field class="hidden-xs-only font-weight-regular mr-4"
							append-icon="mdi-magnify"
							label="Cerca"
							v-model="search"
							clearable
							hide-details
							outlined
							dense
						></v-text-field>

						<v-switch
							inset
							style="padding-top: 0; margin: auto; margin-right: 16px"
							label="Nascondi completati"
							v-model="filterSet['hide_product_saleorder_completed']"
							hide-details
							color="primary"
						></v-switch>
						<v-btn-toggle
							v-model="toggleProcess"
							rounded
						>
							<v-btn value="all" small style="font-size: 12px; height: 40px;">
								Evadi tutto
							</v-btn>
							<v-btn value="ordered" small style="font-size: 12px; height: 40px;">
								Evadi ordinati
							</v-btn>
							<v-btn value="available" small style="font-size: 12px; height: 40px;">
								Evadi disponibili
							</v-btn>
						</v-btn-toggle>
					</v-card-title>
					<v-divider></v-divider>
					<v-container class="pa-0" fluid>
						<v-row class="ma-0 pt-0">
							<v-col cols="12" class="pt-0">
								<v-card class="flex background-2" elevation="0">
									<v-data-table
										class="background-2 no-max-height"
										:headers="tableHeaders"
										:items="filteredItems"
										:search="search"
										hide-default-footer
										disable-pagination
										item-key="id"
										show-expand
										:expanded.sync="expanded">
										<template v-slot:item="{item, select, isSelected, expand, isExpanded, headers, index}">
											<tr class="cursor-pointer" :class="{ 'row-kit': item.type === 'kit' }">
												<template v-for="(header, h) in headers">
													<td v-if="header.value == 'data-table-expand'" :key="'expand-'+h">
														<v-btn
															v-if="item.type === 'kit'"
															icon
															small
															@click.stop="expand(!isExpanded)">
															<v-icon>{{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
														</v-btn>
														<v-btn
															v-else-if="item.description"
															icon
															small
															@click.stop="expand(!isExpanded)">
															<v-icon :size="24" color="info">mdi-file-document</v-icon>
														</v-btn>
													</td>
													<td v-else-if="header.value === 'number'" :key="'number-'+h" :class="['column sortable text-xs-'+(header.align?header.align:'left')]">
														{{ index + 1 }}
													</td>
													<td v-else-if="header.value === 'name'" :key="'name-'+h" :class="['column sortable text-xs-'+(header.align?header.align:'left')]">
														<div class="d-flex align-center">
															<v-icon v-if="item.type === 'kit'" color="primary" small class="mr-2">mdi-package-variant-closed</v-icon>
															{{ item.name }}
															<v-chip v-if="item.type === 'kit'" x-small color="primary" class="ml-2" outlined>KIT</v-chip>
															<v-chip
																v-if="item.type === 'kit' && !item.can_dispatch"
																x-small
																color="warning"
																class="ml-2"
																dark>
																<v-icon x-small left>mdi-alert</v-icon>
																Componenti non disponibili
															</v-chip>
														</div>
													</td>
													<td v-else-if="header.value == 'price'" :key="'price-'+h" :class="['column sortable text-xs-'+(header.align?header.align:'left')]">
														{{ $eventBusUtility.headerValue(header.value, item) | currency }}
													</td>
													<td v-else-if="header.value === 'quantity'" :key="'quantity-'+h">
														<v-chip small color="grey darken-1" dark>
															<v-icon small left>mdi-package-variant</v-icon>
															{{ item.quantity }}
														</v-chip>
													</td>
													<td v-else-if="header.value === 'dispatched_quantity'" :key="'dispatched-'+h">
														<v-chip
															small
															:color="item.dispatched_quantity > 0 ? 'success' : 'grey lighten-1'"
															:dark="item.dispatched_quantity > 0">
															<v-icon small left>mdi-check-circle</v-icon>
															{{ item.dispatched_quantity }}
														</v-chip>
													</td>
													<td v-else-if="header.value === 'quantity_already_ordered'" :key="'ordered-'+h">
														<v-chip
															small
															:color="item.quantity_already_ordered > 0 ? 'info' : 'grey lighten-1'"
															:dark="item.quantity_already_ordered > 0">
															<v-icon small left>mdi-cart-check</v-icon>
															{{ item.quantity_already_ordered }}
														</v-chip>
													</td>
													<td v-else-if="header.type == 'chips'" :class="'text-xs-'+header.align" :key="'chips-'+h">
														<v-chip v-for="(chip, c) in item[header.value]" small :key="c">{{ chip }}</v-chip>
													</td>
													<td v-else-if="header.value == 'quantity_to_process'" :key="'process-'+h"
														:class="['column sortable text-xs-'+(header.align?header.align:'left')]"
														width="200px"
														style="padding-right: 24px !important;">
														<template v-if="item.type === 'description'">
															<v-switch color="primary" inset hide-details class="ma-auto" v-model="item.selected_description" @click.stop></v-switch>
														</template>
														<v-text-field v-else
															v-model.number="item.quantity_to_process"
															class="conversion-quantity"
															label="Quantità"
															type="number"
															min="0"
															hide-details
															:error-messages="errors.collect('Quantità_'+index)"
															v-validate="'required|min_value:0|max_value:'+getMaxDispatchable(item)"
															:data-vv-name="'Quantità_'+index"
															data-vv-as="Quantità"
															dense
															outlined
															@click.stop
															@input="setExistingQuantity(item, index)"
															@change="setExistingQuantity(item, index)"
															:hint="getQuantityHint(item)"
															:persistent-hint="item.type === 'kit'"
														></v-text-field>
													</td>
													<td v-else-if="header.value == 'from_existing'" :key="'existing-'+h" :class="['column sortable text-xs-'+(header.align?header.align:'left')]" width="200px" style="padding-right: 24px !important;">
														<template v-if="item.type === 'description'"></template>
														<v-text-field v-else
															v-model.number="item.from_existing"
															class="conversion-quantity"
															label="Quantità"
															type="number"
															single-line
															hide-details
															:error-messages="errors.collect('Quantità_'+index)"
															v-validate="'required|max_value:'+(roundNumber(item.quantity - item.dispatched_quantity))"
															:data-vv-name="'Quantità_'+index"
															data-vv-as="Quantità"
															dense
															@click.stop
														></v-text-field>
													</td>
													<td v-else-if="header.value === 'selected_lot_allocations'" :key="'lots-'+h">
														<conversion-lots-cell :item="item" quantity-key="quantity_to_process"></conversion-lots-cell>
													</td>
													<td v-else :class="'text-xs-'+header.align" :key="'default-'+h">
														{{ $eventBusUtility.headerValue(header.value, item) }}
													</td>
												</template>
											</tr>
										</template>
										<template v-slot:expanded-item="{ item, headers }">
											<!-- Expanded content for kit components -->
											<tr v-if="item.type === 'kit' && item.components">
												<td :colspan="headers.length" class="pa-4" style="background: #f5f5f5">
													<v-card outlined class="round-card">
														<v-card-title class="pa-3">
															<v-icon left color="primary">mdi-package-variant-closed</v-icon>
															Componenti Kit: {{ item.name }}
														</v-card-title>
														<v-divider></v-divider>
														<v-simple-table dense class="components-table">
															<thead>
																<tr>
																	<th>Componente</th>
																	<th class="text-center">Q.tà per Kit</th>
																	<th class="text-center">Ordinato</th>
																	<th class="text-center">Stock Disponibile</th>
																	<th class="text-center">Stato</th>
																</tr>
															</thead>
															<tbody>
																<tr v-for="(comp, ci) in item.components" :key="ci">
																	<td>
																		<strong>{{ comp.component_name }}</strong>
																		<div class="text-caption grey--text">{{ comp.component_code }}</div>
																	</td>
																	<td class="text-center">
																		<v-chip small color="grey darken-1" dark>
																			{{ comp.quantity_per_kit }}
																		</v-chip>
																	</td>
																	<td class="text-center">
																		<v-chip small :color="comp.ordered_quantity > 0 ? 'info' : 'grey lighten-1'" :dark="comp.ordered_quantity > 0">
																			<v-icon small left>mdi-cart-check</v-icon>
																			{{ comp.ordered_quantity }}
																		</v-chip>
																	</td>
																	<td class="text-center">
																		<v-chip small :color="comp.stock_available > 0 ? 'success' : 'grey'" :dark="comp.stock_available > 0">
																			<v-icon small left>mdi-warehouse</v-icon>
																			{{ comp.stock_available }}
																		</v-chip>
																	</td>
																	<td class="text-center">
																		<v-chip
																			small
																			:color="comp.can_fulfill ? 'success' : 'warning'"
																			dark>
																			<v-icon small left>{{ comp.can_fulfill ? 'mdi-check-circle' : 'mdi-alert' }}</v-icon>
																			{{ comp.can_fulfill ? 'Disponibile' : 'Insufficiente' }}
																		</v-chip>
																	</td>
																</tr>
															</tbody>
														</v-simple-table>
														<v-divider></v-divider>
														<v-card-text class="py-2">
															<v-chip
																:color="item.kit_fully_available ? 'success' : 'warning'"
																dark
																small>
																<v-icon small left>{{ item.kit_fully_available ? 'mdi-check-all' : 'mdi-alert-circle' }}</v-icon>
																{{ item.kit_fully_available ? 'Tutti i componenti disponibili' : 'Max evadibile: ' + item.max_dispatchable_quantity + ' kit' }}
															</v-chip>
														</v-card-text>
													</v-card>
												</td>
											</tr>
											<!-- Expanded content for description -->
											<tr v-else-if="item.description">
												<td :colspan="headers.length" class="pa-0">
													<v-card class="elevation-0" style="height: 100%;">
														<v-card-text pa-4 v-html="item.description"></v-card-text>
													</v-card>
												</td>
											</tr>
										</template>
									</v-data-table>
									<v-divider></v-divider>
								</v-card>
							</v-col>
						</v-row>

						<!-- <v-row class="pt-2 pb-2"  justify="center">
							<v-col lg="2" md="2" sm="6">
								<v-list two-line>
									<v-list-item>
										<v-list-item-action>
											<v-icon color="primary">mdi-currency-eur</v-icon>
										</v-list-item-action>
										<v-list-item-content>
											<v-list-item-title>Imponibile</v-list-item-title>
											<v-list-item-subtitle>{{ models.saleorder.subtotal }}</v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>
								</v-list>
							</v-col>
							<v-col lg="2" md="2" sm="6">
								<v-list two-line>
									<v-list-item>
										<v-list-item-action>
											<v-icon color="primary">mdi-currency-eur</v-icon>
										</v-list-item-action>
										<v-list-item-content>
											<v-list-item-title>Sconto</v-list-item-title>
											<v-list-item-subtitle>{{ models.saleorder.global_discount_total }}</v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>
								</v-list>
							</v-col>
							<v-col lg="2" md="2" sm="6">
								<v-list two-line>
									<v-list-item>
										<v-list-item-action>
											<v-icon color="primary">mdi-currency-eur</v-icon>
										</v-list-item-action>
										<v-list-item-content>
											<v-list-item-title>IVA</v-list-item-title>
											<v-list-item-subtitle>{{ models.saleorder.tax }}</v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>
								</v-list>
							</v-col>
							<v-col lg="2" md="2" sm="6">
								<v-list two-line>
									<v-list-item>
										<v-list-item-action>
											<v-icon color="primary">mdi-currency-eur</v-icon>
										</v-list-item-action>
										<v-list-item-content>
											<v-list-item-title>Totale</v-list-item-title>
											<v-list-item-subtitle>{{ models.saleorder.total }}</v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>
								</v-list>
							</v-col>
						</v-row> -->
					</v-container>
				</v-card>
			</v-col>
			<v-tooltip top>
				<template v-slot:activator="{ on: tooltip }">
					<v-fab-transition slot="activator">
						<v-btn
							v-on="{ ...tooltip }"
							@click.native="confirmProcess = true"
							:loading="saved"
							color="primary"
							dark
							fixed
							bottom
							right
							fab>
							<v-icon>input</v-icon>
						</v-btn>
					</v-fab-transition>
				</template>
				<span>Evadi quantità</span>
			</v-tooltip>

			<confirm-dialog
				:confirmModel="confirmProcess"
				mainTitle="Vuoi evadere le quantità da te selezionate?"
				secondTitle="Sarà creato un DDT con le quantità dei prodotti da te scelte"
				@update:confirmModel="confirmProcess = false"
				:atConfirm="processOrder"
				:confirm="{color: 'info', label: 'crea'}"
			></confirm-dialog>
		</v-col>
	</v-row>
</template>

<script>

import Vue from 'vue'
import ConversionLotsCell from '@/components/common/ConversionLotsCell'
import { missingSerials, conversionPayloadRows } from '@/components/common/conversionLots'

export default {
	name: 'saleorder-process',
	components: { ConversionLotsCell },
	props: {
		id: Number,
	},

	data() {
		return {
			search: '',
			modelDef: 'saleorders',
			models: {},
			infos: {},
			relations: {},
			saved: false,
			footerClass: [],
			dialog: false,
			processAll: false,
			processAvailable: false,
			confirmProcess: false,
			filterSet: {'hide_product_saleorder_completed': true},
			toggleProcess: undefined,
			expanded: [],
		}
	},

	watch: {
		toggleProcess: {
			handler(newValue, oldValue) {
				_.forEach(this.relations.products.collection, (product, p) => {
					let maxDispatchable = this.getMaxDispatchable(product)

					if (newValue === 'all') {
						// Per i kit, limita al massimo evadibile basato sui componenti
						Vue.set(product, 'quantity_to_process', maxDispatchable)
					} else if (newValue === 'ordered') {
						// Quantità ordinata ai fornitori meno quantità già evasa al cliente
						let quantityToprocess = Math.round((product.quantity_already_ordered - product.dispatched_quantity) * 100 + Number.EPSILON ) / 100

						// Assicurati che sia positivo
						if (quantityToprocess < 0) {
							quantityToprocess = 0
						}

						// Limita al massimo evadibile (quantità ordine - già evaso)
						quantityToprocess = Math.min(quantityToprocess, maxDispatchable)

						Vue.set(product, 'quantity_to_process', quantityToprocess)
					} else if (newValue === 'available') {
						let missingQuantity = Math.round((product.quantity - product.dispatched_quantity)* 100 + Number.EPSILON ) / 100
						let quantityToprocess = 0

						if (missingQuantity > 0) {
							// Per i kit, usa max_dispatchable_quantity (basato su disponibilità componenti)
							if (product.type === 'kit') {
								quantityToprocess = product.max_dispatchable_quantity || 0
							} else if(this.$store.getters.checkModulePermissions('banci')) {
								// BANCI: use existing quantity instead of stock
								if (product.existing_quantity > 0) {
									quantityToprocess = missingQuantity < product.existing_quantity ? missingQuantity : product.existing_quantity
								}
							} else {
								// Get min between two values
								if (product.stock > 0) {
									quantityToprocess = missingQuantity < product.stock ? missingQuantity : product.stock
								}
							}
						}
						Vue.set(product, 'quantity_to_process', quantityToprocess)
					} else {
						Vue.set(product, 'quantity_to_process', 0)
					}
					this.setExistingQuantity(product, p)
				})
			}
		}
	},

	created() {

		this.axios.get('saleorders-info-process/' + this.id).then(response => {
			// get body data
			//this.headers = response.data.info.fieldDefs
			this.models = response.data.models
			this.infos = response.data.infos
			this.relations = response.data.relations
			_.forEach(this.relations.products.collection, (product) => {
				Vue.set(product, 'quantity_to_process', 0)
			})
			this.$store.commit('endProgress')

			// Espandi automaticamente i kit
			this.$nextTick(() => {
				this.expanded = this.relations.products.collection.filter(item => item.type === 'kit')
			})

		}, response => {
			// error callback
		})

	},

	computed: {
		filteredItems() {

			let filtered = this.relations.products.collection.filter((item) => {
				if (this.filterSet.hide_product_saleorder_completed) {
					return item.dispatched_quantity < item.quantity
				}
			})

			return filtered.length > 0 ? filtered : this.relations.products.collection
		},

		tableHeaders() {
			if (!this.relations.products || !this.relations.products.info) {
				return []
			}
			return this.relations.products.info.fieldDefs
		}
	},

	methods: {

		roundNumber(num) {
			return Math.round(num * 100 + Number.EPSILON ) / 100
		},

		/**
		 * Get maximum dispatchable quantity for an item
		 * Returns the remaining quantity (ordered - already dispatched)
		 */
		getMaxDispatchable(item) {
			return this.roundNumber(item.quantity - item.dispatched_quantity)
		},

		/**
		 * Get hint text for quantity field
		 */
		getQuantityHint(item) {
			if (item.type === 'kit') {
				return 'Kit - Max: ' + this.getMaxDispatchable(item)
			}
			return ''
		},

		processOrder() {
			this.$validator.validateAll().then(result => {
				if (!result) {
					return false
				}
				const missing = missingSerials(this.relations.products.collection, 'quantity_to_process')
				if (missing.length) {
					this.$store.commit('setSnackbar', {
						timeout: 8000,
						text: 'Indica le matricole di: ' + missing.join(', '),
						value: true,
						color: 'error'
					})
					return false
				}
				this.saved = true
				this.axios.post('saleorders-process/' + this.id, {'products': conversionPayloadRows(this.relations.products.collection)}).then(response => {
					this.saved = false

					// get body data
					this.$router.push({name: 'ddts-show', params: {id: parseInt(response.data.id)}})

				}, response => {
					// error callback
					this.saved = false
				})
			}).catch(() => {

			})
		},


		setExistingQuantity(item) {
			let from_existing = 0
			if (item.quantity_to_process >= item.existing_quantity) {
				from_existing = item.existing_quantity
			} else {
				from_existing = item.quantity_to_process
			}
			let index = this.relations.products.collection.findIndex((el) => el.id === item.id)
			Vue.set(this.relations.products.collection[index], 'from_existing', from_existing)
		},

	},
}
</script>

<style>
	tr.row-kit {
		background-color: #f5f5f5 !important;
	}

	.components-table {
		background: transparent !important;
	}

	.no-max-height .v-data-table__wrapper {
		max-height: none !important;
	}
</style>